export function setloading(state, value) {
    state.loading.module = value;
}
export function setFile(state, value) {
    state.file = value;
}
export function setValidationdata(state, result){
    state.params.validated = result.success

}
export function reset_state(state){
  state.params= {
      file: null,
      validated: false,
  }
}



// WEBPACK FOOTER //
// ./src/modules/import-accounts-plans/mutations.js